<template>
  <div>
    <gmap-map ref="gmap" :center="center" :zoom="zoom" map-type-id="roadmap" :options="customstyles">

      <gmap-info-window :options="infoOptions" :position="infoPosition" :opened="infoOpened"
        @closeclick="infoOpened = false">
        <div v-html="infoContent"></div>
      </gmap-info-window>

      <gmap-marker ref="marker" :key="index" v-for="(marker, index) in markers" :position="marker.position"
        :clickable="true" :draggable="false" :animation="null" :icon="mapIcon" @click="toggleInfo(marker, index)" />

    </gmap-map>

  </div>
</template>

<script>
export default {
  methods: {
    toggleInfo(marker, key) {
      this.infoPosition = marker.position;
      this.infoContent = '<img width="25" src="' + marker.image + '"/>';
      this.infoContent += '<h2>' + marker.name + '</h2>';
      this.infoContent += '<p>' + marker.address.street + '<br/>' + marker.address.city + '</p>';

      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    },
  },
  data() {
    return {
      markers: [
        { image: '../' + require('../../webapp/images/logo.png').default, name: 'fumiX Informatik GmbH & Co. KG', address: { street: 'Rohrbacher Str. 3', city: '69115 Heidelberg' }, position: { lat: 49.4083996, lng: 8.6927648 } }
      ],
      mapIcon: { url: '../' + require('../../webapp/images/marker.png').default },
      zoom: 16,
      center: { lat: 49.4083996, lng: 8.6927648 },
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      customstyles: {
        styles: [
          {
            "elementType": "geometry.fill",
            "stylers": [
              {
                "saturation": -100
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#5c5c5c"
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "labels",
            "stylers": [
              {
                "saturation": -100
              }
            ]
          },
          {
            "featureType": "administrative.locality",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#383838"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "labels.icon",
            "stylers": [
              {
                "color": "#9c9c9c"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#454545"
              }
            ]
          },
          {
            "featureType": "landscape.man_made.building",
            "elementType": "geometry",
            "stylers": [
              {
                "lightness": -4
              },
              {
                "saturation": -100
              }
            ]
          },
          {
            "featureType": "landscape.man_made.business_corridor",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e3e3e3"
              },
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.icon",
            "stylers": [
              {
                "color": "#9c9c9c"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#454545"
              }
            ]
          },
          {
            "featureType": "poi.business",
            "elementType": "geometry",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.medical",
            "elementType": "geometry",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.school",
            "elementType": "geometry",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.sports_complex",
            "elementType": "geometry",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
              {
                "saturation": -100
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#828282"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#383838"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.icon",
            "stylers": [
              {
                "lightness": 25
              },
              {
                "saturation": -100
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#ffffff"
              },
              {
                "saturation": -100
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "labels.text",
            "stylers": [
              {
                "color": "#8f8f8f"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#919191"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#a8caff"
              },
              {
                "saturation": -74
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          }
        ]
      }
    };
  }
};
</script>
